import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import vMultiselectListbox from 'vue-multiselect-listbox'
import { TelechargementOperations } from '@/models/operationssearch.model'
import 'vue-multiselect-listbox/dist/vue-multi-select-listbox.css'

export default {
  data () {
    return {
      loading: false,
      listeMois: [],
      selectedDate: 'Sélectionner une valeur',
      porteursList: [],
      selectedPorteursList: [],
      rechercheRelevesBean: new TelechargementOperations(),
      downloadErrorMessage: ''
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated,
    vMultiselectListbox
  },
  methods: {
    getListeMois () {
      var moment = require('moment')

      // Récupération des mois de -1 à -12 par rapport à la date actuelle
      // (soit mois actuel exclu car pas encore de PDF généré)
      for (var i = 1; i <= 12; i++) {
        var currentDate = new Date()
        currentDate.setDate(1)
        currentDate.setMonth(currentDate.getMonth() - i)

        var dateEnCours = []
        dateEnCours.id = i
        dateEnCours.dateString = moment(currentDate).format('MM/YYYY')
        this.listeMois.push(dateEnCours)
      }
    },
    getRelevesForSelectedDate () {
      if (this.selectedDate > 0) {
        this.selectedPorteursList = []
        this.porteursList = []
        var moment = require('moment')
        this.rechercheRelevesBean.dateDebut = moment(this.listeMois[this.selectedDate - 1].dateString, 'MM/YYYY')
        this.rechercheRelevesBean.selectedEntreprise = this.$store.state.user.user.selectedEntreprise
        this.rechercheRelevesBean.loggedUserLogin = this.$store.state.user.user.login

        this.loading = true
        this.$store.dispatch('porteur/getRelevesPorteur', this.rechercheRelevesBean).then(
          response => {
            this.porteursList = response
            this.loading = false
          },
          error => {
            this.loading = false
            this.errorMessage = error.response.data
          }
        )
      }
    },
    downloadSelectedReleves () {
      if (this.selectedPorteursList.length) {
        if (this.selectedPorteursList.length > 50) {
          this.downloadErrorMessage = 'Merci de sélectionner moins de 50 relevés pour le téléchargement'
        } else {
          let filesToDownload = []
          for (let index = 0; index < this.selectedPorteursList.length; index++) {
            let fileToDownload = {}
            fileToDownload.login = this.$store.state.user.user.login
            fileToDownload.realFileNameToDownload = this.selectedPorteursList[index].realFileNameToDownload
            fileToDownload.keyFolder = this.selectedPorteursList[index].keyFolder
            fileToDownload.nomFichier = this.selectedPorteursList[index].nomFichier
            filesToDownload.push(fileToDownload)
          }

          this.$store.dispatch('entreprise/downloadRelevesPorteurs', filesToDownload).then(
            response => {
              let blob = null
              let finalFileName = ''
              if (filesToDownload.length === 1) {
                blob = new Blob([response], { type: 'application/pdf' })
                let splittedFileName = filesToDownload[0].realFileNameToDownload.split('-')
                let endFileName = splittedFileName[splittedFileName.length - 2] + '-' + splittedFileName[splittedFileName.length - 1]
                finalFileName = filesToDownload[0].nomFichier + '-' + endFileName
              } else {
                blob = new Blob([response], { type: 'application/zip' })
                let splittedFileName = filesToDownload[0].realFileNameToDownload.split('-')
                finalFileName = splittedFileName[splittedFileName.length - 2] + '-operation.zip'
              }

              if ('msSaveOrOpenBlob' in navigator) {
                window.navigator.msSaveOrOpenBlob(blob, finalFileName)
              } else {
                var hiddenElement = document.createElement('a')
                hiddenElement.href = URL.createObjectURL(blob)
                hiddenElement.target = '_blank'
                hiddenElement.download = finalFileName
                document.body.appendChild(hiddenElement)
                hiddenElement.click()
                document.body.removeChild(hiddenElement)
              }
              this.loading = false
            },
            error => {
              this.errorMessage = error.response
              this.loading = false
            }
          )
        }
      }
    }
  },
  created () {
    this.getListeMois()
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Relevés porteurs'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
